import { TweenMax } from 'gsap/TweenMax';
import detectMobile from '@/scripts/utils/detect-mobile';

export default function () {
  const langSwitcher = document.querySelector('[data-type*="language-switcher"]');

  if (!langSwitcher) return;

  const ul = langSwitcher.querySelector('ul');
  const items = Array.from(ul.children);

  let active = items.filter(el => el.className.includes('active'))[0];

  ul.style.overflow = 'hidden';

  function openLangSwitcher() {
    langSwitcher.classList.add('opened');
    TweenMax.to(ul, 0.6, { height: ul.scrollHeight });
  }

  function closeLangSwitcher() {
    langSwitcher.classList.remove('opened');
    TweenMax.to(ul, 0.6, { height: langSwitcher.clientHeight });
  }

  function toggleLangSwitcher() {
    if (langSwitcher.classList.contains('opened')) {
      closeLangSwitcher();
    } else {
      openLangSwitcher();
    }
  }

  if (detectMobile()) {
    langSwitcher.addEventListener('click', toggleLangSwitcher);
  } else {
    langSwitcher.addEventListener('mouseenter', openLangSwitcher);
    langSwitcher.addEventListener('mouseleave', closeLangSwitcher);
  }
  document.addEventListener('click', (e) => {
    if (!$(e.target).closest(langSwitcher).length) {
      closeLangSwitcher();
    } else {
      e.stopPropagation();
    }
  });

  items.forEach((el) => {
    el.addEventListener('click', () => {
      // e.preventDefault();
      if (el === active) return;
      if (active) {
        active.classList.remove('active');
      }
      active = el;
      active.classList.add('active');
      toggleLangSwitcher();
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/elements/language-switcher.js